import AnimateIn from './AnimateIn';
import classNames from 'classnames';

const Caption = ({ children, component, className }) => (
  <AnimateIn
    className={classNames('caption', 'g-row', className, {
      'caption--full': component && component.style !== 'full'
    })}
  >
    {children}
  </AnimateIn>
);

export default Caption;
